import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { Home, Search, Ticket, User, Plus } from 'lucide-react';

export const MobileNav = () => {
  const location = useLocation();
  const { isAuthenticated, isOrganizer, user } = useAuth();

  // Determine profile link - organizers and admins go to dashboard, regular users go to settings
  const isAdmin = user?.role === 'admin';
  const profileLink = isAuthenticated 
    ? (isOrganizer || isAdmin ? '/dashboard' : '/settings') 
    : '/login';

  // Tickets link - regular users go to /my-tickets, organizers/admins go to /dashboard/tickets
  const ticketsLink = isOrganizer || isAdmin ? '/dashboard/tickets' : '/my-tickets';

  const navItems = [
    { href: '/', icon: Home, label: 'Home' },
    { href: '/events', icon: Search, label: 'Explore' },
    ...(isOrganizer ? [{ href: '/dashboard/events/create', icon: Plus, label: 'Create' }] : []),
    { href: ticketsLink, icon: Ticket, label: 'Tickets' },
    { href: profileLink, icon: User, label: 'Profile' },
  ];

  const isActive = (href) => {
    if (href === '/') return location.pathname === '/';
    return location.pathname.startsWith(href);
  };

  return (
    <nav className="mobile-nav md:hidden bg-background/95 backdrop-blur-xl border-t border-border fixed bottom-0 left-0 right-0 z-50" style={{ paddingBottom: 'env(safe-area-inset-bottom, 0px)' }}>
      <div className="flex items-center justify-around py-2 px-4">
        {navItems.map((item) => {
          const Icon = item.icon;
          const active = isActive(item.href);
          
          return (
            <Link
              key={item.href}
              to={item.href}
              className={`flex flex-col items-center gap-1 px-3 py-2 rounded-xl transition-colors ${
                active 
                  ? 'text-primary' 
                  : 'text-muted-foreground hover:text-foreground'
              }`}
              data-testid={`mobile-nav-${item.label.toLowerCase()}`}
            >
              <div className={`p-1.5 rounded-xl ${active ? 'bg-primary/10' : ''}`}>
                <Icon className="w-5 h-5" />
              </div>
              <span className="text-[10px] font-medium">{item.label}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
};

export default MobileNav;
